import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><defs><style></style></defs><path d=\"M992 528H32c-16 0-32-12.8-32-32 0-16 12.8-32 32-32h960c16 0 32 12.8 32 32s-12.8 32-32 32z\" /><path d=\"M544 32v960c0 16-12.8 32-32 32-16 0-32-12.8-32-32V32c0-16 12.8-32 32-32s32 12.8 32 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol